import gql from 'graphql-tag';

export const all = gql`query getInvoices($fogId: ID!) {
    invoices(fogId: $fogId){
        id
        label
        amount
        documentType
    }
}`;


export const get = gql`query getInvoice($id: ID!) {
    invoice(id: $id){
    	id
        label
        amount
        documentType
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/queries/invoice.js